const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ENDPOINTS = {
  LOGIN: `${BASE_URL}/auth/login`,
  MY_INFO: `${BASE_URL}/user/myinfo`,
  GET_CAMP_TEMPLATES: () => `${BASE_URL}/templates/get-templates`,
  GET_WA_TEMPLATE_COUNTS: `${BASE_URL}/wa/get_wa_template_counts`,
  CREATE_TEMPLATE: `${BASE_URL}/templates/create-template`,
  FETCH_TEMPLATES: (page = 1, limit = 10) =>
    `${BASE_URL}/wa/get_wa_templates/?page=${page}&limit=${limit}`,
  GET_WA_AP_TEMPLATES: `${BASE_URL}/wa/get_wa_ap_templates`,
  CREATE_WA_TEMPLATE: `${BASE_URL}/wa/create_wa_template`,
  UPLOAD_TEMPLATE_MEDIA: `${BASE_URL}/wa/create_uploadMedia`,
  UPLOAD_CAMPAIGN_MEDIA: `${BASE_URL}/wa/send_uploadMedia`,
  TEMPLATE_MAPPING: `${BASE_URL}/wamap/template-wa-mapping`,
  SEND_CAMPAIGN_MESSAGE: `${BASE_URL}/webhook/send-message`,
  SEND_CUSTOMISED_CAMPAIGN_MESSAGE: `${BASE_URL}/webhook/send-customized-message`,
  FETCH_REPORT: (templateId) => `${BASE_URL}/wa/report/${templateId}`,
  FETCH_STATUS: (templateId, status, page = 1, limit = 10) =>
    `${BASE_URL}/wa/reportstatus/${templateId}?status=${status}&page=${page}&limit=${limit}`,
  GET_CAMPAIGN_REPORT: `${BASE_URL}/wa/details-report`,
  NUMBER_MESSAGE_REPORT: `${BASE_URL}/wa/number-report`,
  GET_CHAT_HISTORY: `${BASE_URL}/user/get-chat-history`,
  SEND_WHATSAPP: `${BASE_URL}/whatsapp/send`,
  GET_INCOMING_MESSAGES: (page = 1, limit = 10, fromDate, toDate) => {
    let url = `${BASE_URL}/wa/get_incoming_messages?page=${page}&limit=${limit}`;
    if (fromDate) url += `&from_date=${fromDate}`;
    if (toDate) url += `&to_date=${toDate}`;
    return url;
  },
  GET_USER_FLOWS: `${BASE_URL}/bot/user-flows`,
  GET_FLOW_RESPONSES: `${BASE_URL}/bot/flow-responses`,
};
